export const publicVersion = "2.5.2-0-gad45eebb-2026-03-06T12-21-01Z";